import { Card, CardContent } from "@/components/ui/card";
import { Clock, TrendingDown, TrendingUp } from "lucide-react";

interface BestTimesToFlyProps {
  airportName: string;
  airportCode: string;
}

const data = [
  { label: "Best Days", value: "Tuesday, Wednesday", type: "good" as const },
  { label: "Worst Days", value: "Friday, Sunday, Monday", type: "bad" as const },
  { label: "Best Times", value: "5 AM–7 AM, 1 PM–3 PM", type: "good" as const },
  { label: "Worst Times", value: "7 AM–9 AM, 4 PM–7 PM", type: "bad" as const },
];

export const BestTimesToFly = ({ airportName, airportCode }: BestTimesToFlyProps) => {
  return (
    <Card>
      <CardContent className="pt-6">
        <h2 className="text-xl font-bold mb-4 flex items-center gap-2">
          <Clock className="h-5 w-5 text-primary" />
          Best Times to Fly Through {airportName}
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
          {data.map((row) => (
            <div
              key={row.label}
              className={`flex items-start gap-3 p-4 rounded-lg border ${
                row.type === "good"
                  ? "border-primary/20 bg-primary/5"
                  : "border-destructive/20 bg-destructive/5"
              }`}
            >
              {row.type === "good" ? (
                <TrendingDown className="h-5 w-5 text-primary flex-shrink-0 mt-0.5" />
              ) : (
                <TrendingUp className="h-5 w-5 text-destructive flex-shrink-0 mt-0.5" />
              )}
              <div>
                <p className="text-xs font-medium text-muted-foreground uppercase tracking-wide">
                  {row.label}
                </p>
                <p className="font-semibold text-foreground text-sm mt-0.5">{row.value}</p>
              </div>
            </div>
          ))}
        </div>
        <p className="text-xs text-muted-foreground mt-3">
          Based on historical TSA data at {airportCode}. Actual wait times may vary during holidays and special events.
        </p>
      </CardContent>
    </Card>
  );
};
